import { groupOfPeopleJoyfulCoins } from "swing-assets";
import { Card, Colors, Icon } from "swing-components";

import { msg } from "~utils";

type NonSwingCertCardProps = {
  state?: "CA" | "NJ";
  onClick: () => void;
};

export function NonSwingCertCard(props: NonSwingCertCardProps) {
  const { state, onClick } = props;

  if (state === undefined) return null;

  return (
    <div css={{ position: "relative" }}>
      <Card borderColor={Colors.slate200}>
        {/* Close Button */}
        <button
          css={{ position: "absolute", top: 9, right: 9, background: "none" }}
          onClick={onClick}
        >
          <Icon name="Close" color={Colors.blue500} />
        </button>
        <div
          css={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 8,
            backgroundColor: Colors.green200,
            // Using negative margin to offset Card padding
            // so bg can span full width — design confirmed
            // this is a one-off
            margin: -16,
            padding: 16,
            borderRadius: 8,
          }}
        >
          <img src={groupOfPeopleJoyfulCoins} alt={msg("NON_SWING_CERT_CARD_IMG_ALT_TXT")} />

          <div css={{ textAlign: "center", fontSize: 14, lineHeight: "24px" }}>
            <span css={{ fontWeight: 600 }}>{msg("NON_SWING_CERT_CARD_HEADER")}</span>
            <p css={{ margin: 0 }}>{msg("NON_SWING_CERT_CARD_SUBHEADER", { state })}</p>
          </div>
          <a
            href={`https://start.swingeducation.com/swingcert-${state.toLowerCase()}-register`}
            target="_blank"
            rel="noreferrer"
            onClick={onClick}
            style={{
              padding: "8px 16px",
              color: Colors.white200,
              textDecoration: "none",
              fontWeight: 600,
              textAlign: "center",
              borderRadius: 30,
              background: Colors.blue500,
              boxShadow: "0px 2px 4px 0px rgba(40, 60, 93, 0.16)",
            }}
          >
            {msg("NON_SWING_CERT_CTA", { multiplier: state === "CA" ? 2 : 3 })}
          </a>
        </div>
      </Card>
    </div>
  );
}
